import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useQuery, useApolloClient } from '@apollo/client';
import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import 'react-grid-layout/css/styles.css';
import { Responsive as ResponsiveGridLayout } from 'react-grid-layout';
import Typography from '@material-ui/core/Typography';
import { v4 as uuidv4 } from 'uuid';

import { formatActivityTime } from '../util/dateHelpers';
import { GET_CARDHOLDERS, GET_PRS, GET_CARDHOLDERACTIVITY } from '../util/schema';

const useStyles = makeStyles(() => ({
  imageContainer: {
    minWidth: '100%',
    width: 'min-content',
    objectFit: 'contain',
  },
  avatar: {
    width: '100%',
    height: '100%',
    alignSelf: 'center',
  },
  widget: {
    backgroundColor: '#ffffff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
}));

const PhotoRecallWidget = (cardholder, fullname, activity, hoverstatus) => {
  const [cardholderdata, setcurrentcardData] = useState();
  const [configuration, setConfiguration] = useState();
  const [savedLayout, setSavedLayout] = useState();
  const classes = useStyles();

  const [gridarray, setGridArray] = useState([]);
  const [gridsize, setGridSize] = useState();

  const [tabWidgets, setTabWidgets] = useState([]);
  const [defaultPhoto, setdefaultPhoto] = useState(`${window.location.origin}/default_photo.png`);

  const [count, setCount] = useState(0);

  const [prsize, setPRSize] = useState(2);
  const [photoRecallWidgets, setPhotoRecallWidgets] = useState([]);
  const [newPRwidget, setnewPRWidget] = useState();

  const client = useApolloClient();

  const [loading, setLoading] = useState(false);

  async function runQuery() {
    setLoading(true);

    const getCardActivity = await client.query({
      query: GET_CARDHOLDERACTIVITY,
    });

    const getCardData = await client.query({
      query: GET_CARDHOLDERS,
      variables: { first: 1000, skip: count },
    });
    const getPRData = await client.query({ query: GET_PRS });

    let activity = getCardActivity.data.allCardHolderActivity.last7Days
      .map((transaction) => {
        return {
          ...transaction,
        };
      })
      .sort((a, b) => {
        const aTransaction = new Date(a.transTime);
        const bTransaction = new Date(b.transTime);
        return bTransaction - aTransaction;
      });

    const widgetdata = getPRData.data.photoRecallData.photoRecallWidgets;

    const cardarray = getCardData.data.cardholders.edges
      .map((cardholder) => {
        return { ...cardholder };
      })
      .filter((cardholder) => cardholder.lastActivity != null)
      .sort((a, b) => {
        const aDate = new Date(a.lastActivity);
        const bDate = new Date(b.lastActivity);
        return bDate - aDate;
      });

    if (widgetdata.length > 0) {
      const size = widgetdata[0].GridSize;

      if (activity) {
        activity = activity.slice(0, size);
        const thisdata = activity.map((activity) => {
          if (activity.cardHolderId < 0) {
            return {
              cardholderName: activity.cardHolderName,
              id: activity.cardHolderId,
              lastActive: activity.transTime,
              type: 'Cardholder not Found',
            };
          }
          return {
            cardholderName: activity.cardHolderName,
            id: activity.cardHolderId,
            lastActive: activity.transTime,
            type: 'Photo Recall',
          };
        });
        const combined = [];
        if (cardarray) {
          cardarray.slice(0, size);
          setPRSize(cardarray.length);
          setcurrentcardData(cardarray);
        }

        for (let i = 0; i < thisdata.length; i += 1) {
          if (thisdata[i].id > 0) {
            for (let j = 0; j < cardarray.length; j += 1) {
              if (cardarray[j].id === thisdata[i].id) {
                const { photo } = cardarray[j];
                combined.push({ ...thisdata[i], photo });
              }
            }
          } else {
            const photo = null;
            combined.push({ ...thisdata[i], photo });
          }
        }
        setGridArray(combined);
      }
      const value = widgetdata[0].Layout.includes('Value');
      let parsedValue = JSON.parse(widgetdata[0].Layout);
      if (value) {
        const doubleparsed = JSON.parse(parsedValue.Value);
        parsedValue = doubleparsed;
      }

      setPhotoRecallWidgets(widgetdata[0]);
      setConfiguration(widgetdata[0].Configuration);
      setGridSize(widgetdata[0].GridSize);
      setSavedLayout(parsedValue);
      setPRSize(widgetdata[0].PhotoRecallSize);
    } else {
      setnewPRWidget(true);
    }

    setLoading(false);
  }

  const activityCompleted = (activitydata) => {
    let activity = activitydata.allCardHolderActivity.last7Days
      .map((transaction) => {
        return {
          ...transaction,
        };
      })
      .sort((a, b) => {
        const aTransaction = new Date(a.transTime);
        const bTransaction = new Date(b.transTime);
        return bTransaction - aTransaction;
      });

    if (cardholderdata && gridsize) {
      activity = activity.slice(0, gridsize);
      const thisdata = activity.map((activity) => {
        if (activity.cardHolderId < 0) {
          return {
            cardholderName: activity.cardHolderName,
            id: activity.cardHolderId,
            lastActive: activity.transTime,
            type: 'Cardholder not Found',
          };
        }
        return {
          cardholderName: activity.cardHolderName,
          id: activity.cardHolderId,
          lastActive: activity.transTime,
          type: 'Photo Recall',
        };
      });
      const combined = [];
      for (let i = 0; i < thisdata.length; i += 1) {
        if (thisdata[i].id > 0) {
          for (let j = 0; j < cardholderdata.length; j += 1) {
            if (cardholderdata[j].id === thisdata[i].id) {
              const { photo } = cardholderdata[j];
              combined.push({ ...thisdata[i], photo });
            }
          }
        } else {
          const photo = null;
          combined.push({ ...thisdata[i], photo });
        }
      }
      setGridArray(combined);
    }
  };

  useEffect(() => {
    runQuery();

    const interval = setInterval(() => {
      refetch();
      runQuery();
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  const queryError = ({ graphQLErrors, networkError }) => {
    console.log(graphQLErrors);
    console.log(networkError);
  };

  const { data: activitydata, loading: loadingactivity, error: erroractivity, refetch } = useQuery(
    GET_CARDHOLDERACTIVITY,
    {
      onCompleted: activityCompleted,
      onError: queryError,
    }
  );

  const renderGrid = () => {
    let exactTime;
    let activity;

    if (gridarray && configuration && gridsize && savedLayout) {
      const formatted = gridarray.map((cardholder) => {
        exactTime = false;
        activity = formatActivityTime(cardholder.lastActive, exactTime);
        return { ...cardholder, activity };
      });

      const size = Number(gridsize) + 1;

      if (configuration) {
        const actualLayout = savedLayout;

        const savedfree = actualLayout[0];

        if (savedfree != null) {
          const sizelayout = actualLayout.length;
          if (size - 1 === sizelayout) {
            const blocks = [];
            const remainsize = gridsize - formatted.length;
            let lastindex = 0;

            for (let i = 0; i < formatted.length; i += 1) {
              blocks.push({
                i: actualLayout[i].i,
                x: actualLayout[i].x,
                y: actualLayout[i].y,
                w: actualLayout[i].w,
                h: actualLayout[i].h,
                type: formatted[i].type,
                isResizable: false,
                static: true,
              });
              lastindex = i;
            }
            let tempindex = lastindex + 1;

            for (let i = 0; i < remainsize; i += 1) {
              blocks.push({
                i: actualLayout[tempindex].i,
                x: actualLayout[tempindex].x,
                y: actualLayout[tempindex].y,
                w: actualLayout[tempindex].w,
                h: actualLayout[tempindex].h,
                type: 'PhotoRecall Placeholder',
                isResizable: false,
                static: true,
              });
              tempindex += 1;
            }

            const photogrid = [];
            blocks.forEach((blocks, index) => {
              const newKey = uuidv4();
              switch (blocks.type) {
                case 'Cardholder not Found':
                case 'PhotoRecall Placeholder':
                  photogrid.push(
                    <div
                      className={`${classes.widget}`}
                      data-grid={{
                        i: blocks.i,
                        x: blocks.x,
                        y: blocks.y,
                        w: blocks.w,
                        h: blocks.h,
                        type: blocks.type,
                        isResizable: blocks.isResizable,
                        static: blocks.static,
                      }}
                      key={newKey}
                      style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                      }}
                    >
                      <div key={newKey} className={classes.imageContainer}>
                        <Card id={newKey}>
                          <CardMedia
                            style={{
                              display: 'flex',
                            }}
                          >
                            <Avatar
                              variant="square"
                              src={defaultPhoto}
                              className={classes.avatar}
                            />
                          </CardMedia>
                        </Card>
                        <Typography style={{ textAlign: 'center' }}>{'Card Not Found'}</Typography>
                      </div>
                    </div>
                  );
                  break;

                case 'Photo Recall':
                  photogrid.push(
                    <div
                      className={`${classes.widget}`}
                      data-grid={{
                        i: blocks.i,
                        x: blocks.x,
                        y: blocks.y,
                        w: blocks.w,
                        h: blocks.h,
                        type: blocks.type,
                        isResizable: blocks.isResizable,
                        static: blocks.static,
                      }}
                      key={newKey}
                      style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                      }}
                    >
                      <div key={formatted[index].id} className={classes.imageContainer}>
                        <Card id={formatted[index].id}>
                          <CardMedia
                            style={{
                              display: 'flex',
                            }}
                          >
                            <Avatar
                              variant="square"
                              alt={`${formatted[index].formatted}`}
                              src={formatted[index].photo}
                              className={classes.avatar}
                            />
                          </CardMedia>
                        </Card>
                        <Typography style={{ textAlign: 'center' }}>
                          {`${formatted[index].cardholderName} active ${formatted[index].activity}`}
                        </Typography>
                      </div>
                    </div>
                  );

                  break;

                default:
                  break;
              }
            });
            return photogrid;
          }
        }
      }
    }
  };

  const onLayoutChange = (layout) => {};

  return (
    <>
      <>
        <ResponsiveGridLayout
          cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
          rows={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
          onLayoutChange={onLayoutChange}
          autosize
          onBreakpointChange={() => {}}
          useCSSTransforms
          rowHeight={100}
          width={1500}
          compactType={null}
        >
          {renderGrid()}
        </ResponsiveGridLayout>

        {tabWidgets}
      </>
    </>
  );
};

export default PhotoRecallWidget;
